/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import EserviceSummary from './EserviceSummary';
import ServicesLayout from '../../components/ServicesLayout';
import {
  isUserLoggedIn,
  fetchClaim,
  validateClaimOwnership,
  fetchDeliveryMethods,
  fetchPaymentMethods,
  fetchDistricBankAccounts,
  fetchService
} from '../../lib/utils';

const title = 'Podsumowanie wniosku';


// cbf2be97-d5e4-4c6c-8821-bb6f072214ea

export default {

  path: '/eserviceSummary/:jobID',

  async action(ctx) {
    // unpack context variable
    const { params, store, query } = ctx;

    if (params.jobID === undefined || params.jobID === 'undefined') return { redirect: '/' };

    // fetch job details url
    const claim = await fetchClaim(params.jobID);

    // if there is no claim with this job id then return to error page
    if (!claim) return null;

    const state = store.getState();
    // checks is u're logged in
    const isUserLogged = isUserLoggedIn(state, query, claim.prefix);
    if (!(isUserLogged === true)) {
      return isUserLogged;
    }

    // fetch payment methods
    const deliveryMethods = await fetchDeliveryMethods(claim.teryt);
    const paymentMethods = await fetchPaymentMethods(claim.teryt);
    const bankAccounts = await fetchDistricBankAccounts(claim.teryt);

    // validates claim ownership
    if (!validateClaimOwnership(claim, state)) return { redirect: '/' };
    if (!bankAccounts) {
      return { title, component: <ServicesLayout>Niepoprawnie wypełnione dane gminy, dalsze postępowanie w Twojej sprawie jest niemożliwe. Przepraszamy.</ServicesLayout> };
    }
    const eserviceDistrict = await fetchService(claim.teryt, claim.shortName);

    return {
      title,
      component: <ServicesLayout>
        <EserviceSummary
          title={title}
          {...deliveryMethods}
          {...paymentMethods}
          {...params}
          claim={claim}
          user={state.user}
          {...bankAccounts}
          eserviceDistrict={eserviceDistrict}
        /></ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/eserviceSummary/index.js